/**
 * JSDoc imports.
 *
 * @import { DynamicConfig } from '@app/types';
 */
export class DesignerSetting {
    /** @returns {DynamicConfig & { lastBuild: number; }} */
    static get s() {
        const user = JSON.parse(window.localStorage.getItem('user'));
        // dynamicConfig is created by a script that `server.js` injects into the HTML at runtime.
        const { dynamicConfig } = window;

        return {
            ...dynamicConfig,
            /** Logged in designer. */
            author: user?.username ?? dynamicConfig.author,
            /** Last build timestamp replaced using webpack at build time. */
            lastBuild: parseInt(__DES_LAST_BUILD__, 10),
        };
    }
}

export default DesignerSetting;
